import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';

import * as State from '@shared/state';

@Component({
    selector: 'shared-tag-images',
    templateUrl: './tag-images.shared.component.html',
    styleUrls: ['./tag-images.shared.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagImagesComponent implements OnInit {
    @Input() public images: State.IDietaryTagImage[] = [];

    constructor() { }

    ngOnInit(): void { }

    public trackBy(index: number, image: State.IDietaryTagImage): number {
        return image?.Id || index;
    }
}
